import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SortField } from '../../../../generic/classes/sortfield';
import { SortComponent } from '../../../../generic/component/sort/sort.component';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'pending-order-detail-sort',
    templateUrl: 'pending.order.detail.sort.component.html',
    standalone: true,
    imports: [FormsModule],
})
export class PendingOrdersDetailSortComponent
    extends SortComponent
    implements OnInit {
    activeSortFieldKeyAndOrder: string;
    @Output() sortChangeEvent = new EventEmitter();
    @Input() labelSortDescription: string;
    @Input() labelSortInserted: string;
    @Input() labelSortWithoutBarcode: string;
    @Input() labelSortVolume: string;
    @Input() labelSortQuantity: string;
    @Input() labelSortGrower: string;
    @Input() labelSortPrice: string;

    constructor() {
        super();
        this.activeSortFieldKeyAndOrder = 'inserted|ASC';
    }

    getActiveSortFieldKey(): string {
        return this.activeSortFieldKeyAndOrder.split('|')[0];
    }

    getActiveSortFieldDirection(): string {
        return this.activeSortFieldKeyAndOrder.split('|')[1];
    }

    getSortFields(): SortField[] {
        return [
            new SortField(
                'description',
                this.labelSortDescription,
                true,
                false,
            ),
            new SortField('inserted', this.labelSortInserted, true, false),
            new SortField('barcode', this.labelSortWithoutBarcode, true, false),
            new SortField('volume', this.labelSortVolume, true, false),
            new SortField('quantity', this.labelSortQuantity, true, false),
            new SortField('price', this.labelSortPrice, true, false),
        ];
    }

    override ngOnInit(): void {
        super.ngOnInit();
    }

    onChangeActiveSortField() {
        this.setApplicableSortFields();

        this.sortChangeEvent.emit({
            key: this.getActiveSortFieldKey(),
            direction: this.getActiveSortFieldDirection(),
        });
    }
}
